import React, {FunctionComponent} from 'react';
import PublicIcon from '../../../assets/icons/classification/public.svg?react';
import ProprietaryIcon from '../../../assets/icons/classification/proprietary.svg?react';
import SensitiveIcon from '../../../assets/icons/classification/sensitive.svg?react';
import ConfidentialIcon from '../../../assets/icons/classification/confidential.svg?react';
import PublicMarkIcon from '../../../assets/icons/classification/public-mark.svg?react';
import ProprietaryMarkIcon from '../../../assets/icons/classification/proprietary-mark.svg?react';
import SensitiveMarkIcon from '../../../assets/icons/classification/sensitive-mark.svg?react';
import ConfidentialMarkIcon from '../../../assets/icons/classification/confidential-mark.svg?react';
import ExclamationMarkIcon from '../../../assets/icons/classification/exclamation-mark.svg?react';

const informationClassificationComponentMap: {[key: string]: FunctionComponent<React.SVGProps<SVGSVGElement>>} = {
  Public: PublicIcon,
  Proprietary: ProprietaryIcon,
  Sensitive: SensitiveIcon,
  Confidential: ConfidentialIcon,
};

const informationClassificationMarkComponentMap: {[key: string]: FunctionComponent<React.SVGProps<SVGSVGElement>>} = {
  Public: PublicMarkIcon,
  Proprietary: ProprietaryMarkIcon,
  Sensitive: SensitiveMarkIcon,
  Confidential: ConfidentialMarkIcon,
};

export type InformationClassificationIconProps = React.SVGProps<SVGSVGElement> & {
  classification: string;
  markOnly?: boolean;
};

export const InformationClassificationIcon: React.FC<InformationClassificationIconProps> = ({
  classification,
  markOnly = false,
  ...iconProps
}) => {
  const map = markOnly ? informationClassificationMarkComponentMap : informationClassificationComponentMap;
  const ClassificationIcon = map[classification];

  if (ClassificationIcon) {
    return <ClassificationIcon {...iconProps} />;
  }

  if (markOnly) {
    return <ExclamationMarkIcon {...iconProps} />;
  }

  return null;
};
